/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../Sidebar.css';
import Link from '../../Link';

class SidebarAboutUs extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className={s.root} role="navigation">
        <ul className={s.menu}>
          <li
            className={this.props.title === 'Company Profile' ? s.current : ''}
          >
            <Link className={s.link} to="/about-us/company-profile">
              Company Profile
            </Link>
          </li>
          <li className={this.props.title === 'Meet Our Team' ? s.current : ''}>
            <Link className={s.link} to="/about-us/meet-our-team">
              Meet Our Team
            </Link>
          </li>
          <li
            className={this.props.title === 'Factory Plants' ? s.current : ''}
          >
            <Link className={s.link} to="/about-us/factory-plants">
              Factory Plants
            </Link>
          </li>
          <li
            className={this.props.title === 'Quality Policy' ? s.current : ''}
          >
            <Link className={s.link} to="/about-us/quality-policy">
              Quality Policy
            </Link>
          </li>
          {/*
          <li
            className={
              this.props.title === 'Bricks Manufacturing' ? s.current : ''
            }
          >
            <Link className={s.link} to="/about-us/bricks-manufacturing">
              Bricks Manufacturing
            </Link>
          </li>
          */}
        </ul>
      </div>
    );
  }
}

export default withStyles(s)(SidebarAboutUs);



// WEBPACK FOOTER //
// ./src/components/Sidebar/AboutUs/AboutUs.js